/**
 * Injeta um trecho HTML contendo <script>, <noscript> ou ambos.
 * Preserva scripts externos (src) e internos (inline) sem executar conteúdo duplicado.
 */
export function loadScriptContent(htmlSnippet, jaCarregado = false) {
  if (jaCarregado) return false;

  try {
    if (!htmlSnippet?.trim()) {
      // fallback: script padrão
      return carregaAnalyticsCi();
    }

    // Converte string em DOM sem acrescentar ao documento
    const parser = new DOMParser();
    const tempDoc = parser.parseFromString(htmlSnippet, 'text/html');

    /* 1. <noscript> */
    tempDoc.querySelectorAll('noscript').forEach(ns => {
      const clone = document.createElement('noscript');
      clone.innerHTML = ns.innerHTML;
      document.body.appendChild(clone);
    });

    /* 2. <script> (externos e inline) */
    tempDoc.querySelectorAll('script').forEach(srcNode => {
      const script = document.createElement('script');

      // Copia todos os atributos (src, async, defer, type…)
      [...srcNode.attributes].forEach(attr => {
        script.setAttribute(attr.name, attr.value);
      });

      // Se não houver src, copia o código inline
      if (!script.hasAttribute('src')) {
        script.textContent = srcNode.textContent;
      }

      document.head.appendChild(script);
    });

    console.log('Snippet de script/noscript carregado com sucesso');
    return true;
  } catch (err) {
    console.error('Falha ao carregar snippet:', err);
    // fallback: script padrão
    return carregaAnalyticsCi();
  }
}

/** Carrega o analytics padrão quando não há snippet do revendedor. */
export function carregaAnalyticsCi() {
  const defaultScript = document.createElement('script');
  defaultScript.async = true;
  defaultScript.defer = true;
  defaultScript.src = 'https://www.chatinteligente.com.br/js/analytics.js?v=1.0.0';
  document.head.appendChild(defaultScript);
  console.log('Script padrão carregado.');
  return true;
}
